import GraphRanges from "@/mixins/GraphRanges";
import { patientNamespace } from "@/store/modules/patient";
import { Point } from "chart.js";
import _ from "lodash";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { MultiChartConfig } from "../shared/chart/MultiChartWithSharedRange";
import { defaultTooltipLabelCallback } from "../shared/chart/VueChart";

// Value is unknown so server sends -1
const OCCURRENCE_VALUE = -1;

@Component({})
export default class Urine extends mixins(GraphRanges) {
  @Getter("segmentRisk", patientNamespace)
  segmentRisk!: any;

  @Getter("graph", patientNamespace)
  graph!: any;

  @Getter("config", patientNamespace)
  config!: any;

  get charts(): MultiChartConfig[] {
    return [
      {
        title: "Urine Rate (mL/kg/hr)",
        data: this.graph([{ label: "Urine Rate", key: "urineRate" }]),
        suggestedMax: 1
      },
      {
        type: "bar",
        title: "Urine Output (mL)",
        data: this.urineData,
        library: this.urineOutputLibrary,
        suggestedMax: 2
      }
    ];
  }

  get urineData() {
    const baseGraph = _.cloneDeep(this.graph(["Urine"]));
    const urineValuePoints: Array<Point> = [];
    const urineOccurrencePoints: Array<Point> = [];
    if (baseGraph && baseGraph[0] && baseGraph[0].data) {
      const data = baseGraph[0].data;

      // pull out occurences which are recorded as -1
      data.forEach((d: Point) => {
        if (d.y === OCCURRENCE_VALUE) {
          // Set y to 0 so it is drawn on the x-axis
          d.y = 0;
          urineOccurrencePoints.push(d);
        } else {
          urineValuePoints.push(d);
        }
      });
      baseGraph[0].data = urineValuePoints;
      baseGraph.push({
        label: "Occurrence",
        data: urineOccurrencePoints,
        type: "line",
        pointRadius: 5,
        pointHoverRadius: 6,
        pointStyle: "rectRot" // diamond or rectangle rotated
      });
    }

    return baseGraph;
  }

  get urineOutputLibrary() {
    return {
      // hide lines for occurence chart
      showLines: false,
      tooltips: {
        callbacks: {
          label: function(
            tooltipItem: Chart.ChartTooltipItem,
            data: Chart.ChartData
          ) {
            // Urine is first dataset
            if (tooltipItem.datasetIndex === 0) {
              return defaultTooltipLabelCallback(tooltipItem, data);
            } else if (tooltipItem.datasetIndex === 1) {
              // occurrence is second data set and shouldn't show a value
              // because it is unknown
              return "Occurrence";
            }
          }
        }
      },
      legend: {
        labels: {
          usePointStyle: true
        }
      },
      scales: {
        xAxes: [
          {
            maxBarThickness: 8,
            minBarThickness: 6,
            barThickness: 6
          }
        ]
      }
    };
  }
}
